var _path, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#265a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "266b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#266b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB0624",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF100",
    fillRule: "evenodd",
    d: "M10.692 10.116a3 3 0 0 0 .616 0L11 9.332zm-1.42-.581c-.549-.442-.891-1.086-.891-1.803 0-.846.478-1.59 1.198-2.016l.897 2.283zm3.149-3.819c.72.427 1.198 1.17 1.198 2.016 0 .718-.344 1.362-.89 1.803l-1.205-1.536zm-.105-.06A2.8 2.8 0 0 0 11 5.332c-.48 0-.93.117-1.316.324L11 7.331z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF100",
    fillRule: "evenodd",
    d: "M11 12.8c2.603 0 4.714-2.15 4.714-4.8S13.604 3.2 11 3.2C8.397 3.2 6.286 5.348 6.286 8s2.11 4.8 4.714 4.8m0-1.067c2.025 0 3.667-1.672 3.667-3.734S13.025 4.266 11 4.266 7.333 5.937 7.333 7.999 8.975 11.733 11 11.733",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "265a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagKg = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagKg);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";